import React from 'react';
import { copyTextToClipboard } from '@gamiphy/utils/general';

export const useOnCopy = (text: string | undefined): {
  copied: boolean,
  onCopy: () => Promise<void>
} => {
  const [copied, setCopied] = React.useState(false);

  const onCopy = React.useCallback(async () => {
    if (!copied && text) {
      await copyTextToClipboard(text);
      setCopied(true);
      const interval = setInterval(() => {
        setCopied(false);
        clearInterval(interval);
      }, 2000);
    }
  }, [copied, text]);

  return {
    copied,
    onCopy,
  };
};
